import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/app/(ordering)/shop/menu/page.tsx");
